
import {
  Component, Vue, Prop, Ref,
} from 'vue-property-decorator'
import ViewModel from '@/models/ViewModel'
import DataTable from '@/components/DataTable/index.vue'
import PublisherReconciliation from '@/models/PublisherReconciliation'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import util from '@/mixins/util'
import WebMessage from '@/models/WebMessage'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import Widget from '@/components/Widget/Widget.vue'
import row_fields from '../fields/unmatched-fields'

@Component({
  mixins: [util],
  components: {
    DataTable,
    Widget,
    SearchInput,
    IconAction,
  },
})
class PublisherReconciliationUnmatched extends ViewModel {
  @Ref() readonly dataTable!: HTMLFormElement

  @Prop()
  public billingMonth!: any

  // =====

  public records: number = 0

  public loading: boolean = false

  public ready = false

  public query: string[] = []

  public selected: string[] = []

  public fieldFilters: any = {}

  public query_settings: any = {}

  public fields: Array<any> = []

  public parent_fields: Array<any> = [
    {
      key: 'invoice_number',
      label: 'Invoice Number',
      sortable: true,
      thClass: 'align-middle text-center',
      tdClass: 'align-middle text-center text-uppercase',
      show: true,
    },
    {
      key: 'invoice_file_name',
      label: 'Invoice File',
      sortable: true,
      thClass: 'align-middle text-center',
      tdClass: 'align-middle text-center text-uppercase',
      show: true,
    },
    {
      key: 'amount_total',
      label: 'Amount Total',
      sortable: true,
      thClass: 'align-middle text-center',
      tdClass: 'align-middle text-center',
      show: true,
      type: 'currency',
    },
    {
      key: 'created_at',
      label: 'Created At',
      sortable: true,
      thClass: 'align-middle text-center',
      tdClass: 'align-middle text-center',
      show: true,
      type: 'date',
    },
    {
      key: 'reasons_count',
      label: 'Reasons Count',
      sortable: true,
      thClass: 'align-middle text-center',
      tdClass: 'align-middle text-center',
      show: true,
      type: 'numeral',
    },
    {
      key: 'action',
      label: '',
      sortable: false,
      thClass: 'align-middle text-center',
      tdClass: 'align-middle text-center',
      type: 'action_list',
      show: true,
    },
  ]

  public fieldFiltersKeys!: (fieldFilters: any) => string[]

  // =====

  public get show_fields() {
    return this.parent_fields.filter((f: any) => f.show)
  }

  public get show_child_fields() {
    return row_fields.filter((f: any) => f.show)
  }

  // =====

  public mounted() {
    this.fields = row_fields
    this.loadFilters()
  }

  public statusVariant(status: string): string {
    switch (status) {
      case 'approved':
        return 'success'
      case 'pending':
        return 'warning'
      default:
        return 'secondary'
    }
  }

  public async rows(ctx: any): Promise<any> {
    this.loading = true

    try {
      const field_filters = this.fieldFiltersKeys(this.fieldFilters)

      this.syncFilters()

      const result = await PublisherReconciliation.getUnmatches(this.billingMonth, {
        page_size: ctx.perPage,
        page: ctx.currentPage,
        order_by: 'period',
        order: 'desc',
        query: [...ctx.filter, ...field_filters],
        mode: 'exclusive',
      })
      this.records = result.records
      return result.data
    } catch (error) {
      // @ts-nocheck
      console.error('Error loading unmatched rows:', error)
    } finally {
      this.loading = false
    }
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'publisher-reconciliation-unmatched',
      data: { query: this.query, fieldFilters: this.fieldFilters },
    })
  }

  public loadFilters() {
    const system = getModule(SystemtModule)
    system.getFilter('publisher-reconciliation-unmatched').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
      }
      this.ready = true
    })
  }

  public refresh() {
    this.dataTable.refresh()
  }
}
export default PublisherReconciliationUnmatched
